export class CrossDomainLinkService {
    async initCrossDomainLinks(): Promise<void> {
        const crossDomainLinks = document.querySelectorAll<HTMLAnchorElement>('a[data-cross-domain]');
        for (const crossDomainLink of crossDomainLinks) {
            const originalUrl: string = crossDomainLink.href;
            const targetUrl = new URL(originalUrl, window.location.origin);

            if (targetUrl.hostname !== window.location.hostname) {
                crossDomainLink.href = await this.getCrossDomainUrl(originalUrl)
            }
        }
    }

    async getCrossDomainUrl(originalUrl: string): Promise<string> {
        const targetUrl = new URL(originalUrl, window.location.origin);

        if (targetUrl.hostname !== window.location.hostname) {
            // add usercentrics controller id
            if (window.__ucCmp !== undefined && typeof window.__ucCmp.getControllerId === 'function') {
                const controllerId = await window.__ucCmp.getControllerId() as string;
                targetUrl.searchParams.set('usercentrics-controller-id', controllerId);
            }
            // add convert
            if (window.convert !== undefined) {
                if (!targetUrl.searchParams.has('_conv_s') && window.convert.getCookie('_conv_s')) {
                    targetUrl.searchParams.set('_conv_s', window.convert.getCookie('_conv_s') as string);
                }
                if (!targetUrl.searchParams.has('_conv_v') && window.convert.getCookie('_conv_v')) {
                    targetUrl.searchParams.set('_conv_v', window.convert.getCookie('_conv_v') as string);
                }
            }
        }

        return targetUrl.toString();
    }
}


(<any>window).skyComponents = (<any>window).skyComponents || {};
(<any>window).skyComponents.crossDomainLinkService = new CrossDomainLinkService();
document.addEventListener('DOMContentLoaded', () => {
    const ucScript = document.getElementById("usercentrics-cmp") as HTMLScriptElement | null;

    if (ucScript) {
        if (window.__ucCmp) {
            void (<any>window).skyComponents.crossDomainLinkService.initCrossDomainLinks();
        } else {
            ucScript.addEventListener("load", () => {
                void (<any>window).skyComponents.crossDomainLinkService.initCrossDomainLinks();
            });
        }
    }
});
